export enum ScanType {
  Ids = 0,
  Invoices = 1,
  Receipts = 2,
  HealthInsuranceCards = 3
}
